<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">Edit Lead</div>
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/leads/detail?id=' + id_lead)" class="link-back">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="validateRegister">
          <div class="font-bold mt-20">Lead Information</div>
          <hr class="short-line left" />
          <div class="row mb-30">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Owner</div>
                </b-col>
                <b-col sm="9">
                  <template v-if="checkSessionRoleId === '4'">
                    <b-form-select
                      name="lead_owner"
                      v-validate="'required'"
                      v-model="editData.owner_id"
                      class="form-control border-bottom"
                    >
                      <option value="null">Please select</option>
                      <option
                        v-for="item in itemSales"
                        :key="item.id"
                        :value="item.id"
                      >{{item.fullname}}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                  <template v-else>
                    <b-form-select
                      name="lead_owner"
                      v-validate="'required'"
                      disabled
                      v-model="editData.owner_id"
                      class="form-control border-bottom bg-transparent"
                    >
                      <option value="null">Please select</option>
                      <option
                        v-for="item in itemSales"
                        :key="item.id"
                        :value="item.id"
                      >{{item.fullname}}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lead_owner') }}</span>
                  </template>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Refferal Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select
                      autocomplete="false"
                      :options="optionsMember"
                      @searchchange="searchMemberWithoutBranch"
                      class="border-bottom"
                      placeholder="Select member"
                      name="member_id"
                      v-model="editData.member_id"
                    ></model-select>
                    <p>{{ currentData.referral_member ? currentData.referral_member.first_name + ' ' + currentData.referral_member.last_name : '' }}</p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Branch</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="form-control border-bottom" name="branch" v-model="branch_id" @change="changeBranch">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Refferal PT</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                      name="refferal_pt_id"
                      v-model="editData.referral_pt_id"
                      class="form-control border-bottom"
                    >
                      <option value="null">Please select</option>
                      <option
                        v-for="item in itemsPT"
                        :key="item.id"
                        :value="item.id"
                      >{{item.name}}</option>
                    </b-form-select>
                    <p>{{ currentData.referral_pt ? currentData.referral_pt.name  : '' }}</p>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Lead Source</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    name="lead_source"
                    v-validate="'required'"
                    v-model="editData.source_type_id"
                    class="form-control border-bottom"
                  >
                    <option value="null">Please select</option>
                    <option v-for="item in itemSource" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('lead_source') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">First Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.first_name"
                    name="first_name"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('first_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Last Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.last_name"
                    name="last_name"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('last_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Email</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    name="email"
                    v-validate="'required'"
                    v-model="editData.email"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">ID Card</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    name="id_card"
                    v-validate="'required'"
                    v-model="editData.no_ktp"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('id_card') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Birthday</div>
                </b-col>
                <b-col sm="9">
                  <flat-pickr
                    :config="config"
                    v-model="editData.birthday"
                    name="birthday"
                    v-validate="'required'"
                    class="w-100"
                  ></flat-pickr>
                  <span class="error">{{ errors.first('birthday') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Gender</div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group
                    id="radioGender"
                    v-validate="'required|included:1,2'"
                    v-model="editData.gender"
                    name="gender_info"
                  >
                    <b-form-radio class="font-13" value="1">Male</b-form-radio>
                    <b-form-radio class="font-13" value="2">Female</b-form-radio>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first('gender_info') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Phone Number</div>
                </b-col>
                <b-col sm="3">
                  <model-select autocomplete="false" :options="optionCountryCode"
                      @searchchange="onCountryCode" class="border-bottom" placeholder="country code"
                      name="country_code" v-model="editData.phone_country_code"></model-select>
                </b-col>
                <b-col sm="6">
                  <b-form-input
                    class="form-control border-bottom"
                    name="phone_number"
                    v-validate="'required|regex:^[1-9][0-9]*$'"
                    v-model="editData.phone_number"
                    type="text"
                    @blur="normalizePhoneNumber('phone_number')"
                  ></b-form-input>
                  <span class="error">{{ errors.first('phone_number') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Home Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-validate="'required|numeric'"
                    name="home_number"
                    v-model="editData.home_number"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('home_number') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Address</div>
                </b-col>
                <b-col sm="9">
                  <textarea
                    class="form-control"
                    v-validate="'required'"
                    name="address"
                    v-model="editData.address"
                    rows="3"
                  ></textarea>
                  <span class="error">{{ errors.first('address') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Current Address</div>
                </b-col>
                <b-col sm="9">
                  <textarea
                    class="form-control"
                    name="current_address"
                    v-model="editData.current_address"
                    rows="3"
                  ></textarea>
                  <span class="error">{{ errors.first('current_address') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Contact</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-validate="'required'"
                    name="emergency_contact"
                    v-model="editData.emergency_contact"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('emergency_contact') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Emergency Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-validate="'required|numeric'"
                    name="emergency_number"
                    v-model="editData.emergency_number"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('emergency_number') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Document Type</div>
          <hr class="short-line left" />
          <div class="row mb-30">
            <div class="col-sm-6">
              <b-row>
                <b-col sm="3">
                  <label>Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    name="document_type"
                    v-validate="'required'"
                    v-model="editData.doc_name"
                    class="form-control border-bottom"
                  >
                    <option value="null" selected>Please select</option>
                    <!-- <option value="form_paradigm_1.hbs">Form Paradigm 1</option>
                    <option value="form_paradigm_2.hbs">Form Paradigm 2</option>
                    <option value="form_paradigm_3.hbs">Form Paradigm 3</option>
                    <option value="form_paradigm_4.hbs">Form Paradigm 4</option>
                    <option value="form_paradigm_5.hbs">Form Paradigm 5</option>
                    <option value="form_paradigm_6.hbs">Form Paradigm 6</option>
                    <option value="form_paradigm_7.hbs">Form Paradigm 7</option>
                    <option value="form_paradigm_8.hbs">Form Paradigm 8</option>
                    <option value="form_paradigm_9.hbs">Membership DS</option> -->
                    <!-- <option value="form_paradigm_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_4.hbs">P4 : Corporate dan Family Membership CC sendiri</option>
                    <option value="form_paradigm_5.hbs">P5 : Corporate dan Family Membership CC orang lain</option>
                    <option value="form_paradigm_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun</option>
                    <option value="form_paradigm_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)</option>
                    <option value="form_paradigm_8.hbs">P8 : Beta Plus Membership</option>
                    <option value="form_paradigm_9.hbs">Membership DS</option> -->
                     <option value="form_paradigm_lp_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_4.hbs">P4 : Corporate dan Family Membership CC sendiri (LP)</option>
                    <option value="form_paradigm_lp_5.hbs">P5 : Corporate dan Family Membership CC orang lain (LP)</option>
                    <option value="form_paradigm_lp_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (LP)</option>
                    <option value="form_paradigm_lp_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (LP)</option>
                    <option value="form_paradigm_lp_8.hbs">P8 : Beta Plus Membership (LP)</option>

                    <option value="form_paradigm_sq_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SQ)</option>
                    <option value="form_paradigm_sq_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SQ)</option>
                    <option value="form_paradigm_sq_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SQ)</option>
                    <option value="form_paradigm_sq_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (SQ)</option>
                    <option value="form_paradigm_sq_8.hbs">P8 : Beta Plus Membership (SQ)</option>

                    <option value="form_paradigm_sms_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SMS)</option>
                    <option value="form_paradigm_sms_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SMS)</option>
                    <option value="form_paradigm_sms_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SMS)</option>
                    <option value="form_paradigm_sms_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (SMS)</option>
                    <option value="form_paradigm_sms_8.hbs">P8 : Beta Plus Membership (SMS)</option>

                    <option value="form_paradigm_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega)</option>
                    <option value="form_paradigm_4.hbs">P4 : Corporate dan Family Membership CC sendiri</option>
                    <option value="form_paradigm_5.hbs">P5 : Corporate dan Family Membership CC orang lain</option>
                    <option value="form_paradigm_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun</option>
                    <option value="form_paradigm_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)</option>
                    <option value="form_paradigm_8.hbs">P8 : Beta Plus Membership</option>
                    <option value="form_paradigm_9.hbs">Membership DS</option>
                    <option value="form_paradigm_9_efd_2024.hbs">Membership DS EFD</option>
                    <option value="form_paradigm_9_sq_efd_2024.hbs">Membership SQ EFD</option>
                    <option value="form_paradigm_9_lp_efd_2024.hbs">Membership LP EFD</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('document_type') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>
          <!-- <div class="font-bold mt-20">Personal Information</div>
          <hr class="short-line left">
          <div class="row mb-20">
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Place of Birth</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.tempat_lahir" name="placeOfBirth"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('placeOfBirth') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Nationality</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.kewarganegaraan" name="nationality"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('nationality') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Religion</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="religion"  v-model="editData.agama" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option value="Islam">Islam</option>
                    <option value="Kristen">Kristen</option>
                    <option value="Katolik">Katolik</option>
                    <option value="Hindu">Hindu</option>
                    <option value="Buddha">Buddha</option>
                    <option value="Konghucu">Konghucu</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('religion') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Maritial Status</div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group id="maritial_status"  v-model="editData.status_perkawinan" name="maritial_status">
                    <b-form-radio class="font-13" value="Belum Kawin">Single</b-form-radio>
                    <b-form-radio class="font-13" value="Kawin">Marriage</b-form-radio>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first('maritial_status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Blood type</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="bloodType"  v-model="editData.golongan_darah" class="form-control border-bottom">
                    <option value="null" selected>Please select</option>
                    <option value="O">O</option>
                    <option value="A">A</option>
                    <option value="AB">AB</option>
                    <option value="B">B</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('Blood type') }}</span>
                </b-col>
              </b-row>
            </div>
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Province</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.provinsi" name="province"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('province') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Regency</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.kota" name="regency"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('regency') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">District</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.kecamatan" name="district"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('district') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Sub District</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.kelurahan" name="subDistrict"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('subDistrict') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">RT/RW</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.rt_rw" name="rt_rw"  type="text"></b-form-input>
                  <span class="error">{{ errors.first('rt_rw') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>-->
          <div class="row mb-20">
            <div class="col-lg-6">
              <div class="font-bold mt-20">Upload Data Personal</div>
              <hr class="short-line left" />
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Selfie Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType"
                    v-model="getPictureType"
                    name="getPictureType"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.selfie_photo == '' || editData.selfie_photo == null">
                      <span class="error">The selfie_photo field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video" id="video" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto'"
                        id="takePhotoCanvas"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType === 'uploadFile'">
                    <b-form-file
                      name="selfie_photo"
                      @change="previewImage"
                      accept="image/*"
                      v-model="editData.selfie_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData" />
                    </div>
                    <!-- <span class="error">{{ errors.first('selfie_photo') }}</span> -->
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">ID Card Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType2"
                    v-model="getPictureType2"
                    name="getPictureType2"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType2 === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera2">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.ktp_photo == '' || editData.ktp_photo == null">
                      <span class="error">The id_card field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture2'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture2')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video2" id="video2" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera2()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture2">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto2'"
                        id="takePhotoCanvas2"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType2 === 'uploadFile'">
                    <b-form-file
                      name="id_card"
                      @change="previewImage2"
                      accept="image/*"
                      v-model="editData.ktp_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData2.length > 0">
                      <img class="preview" :src="imageData2" />
                    </div>
                    <!-- <span class="error">{{ errors.first('id_card') }}</span> -->
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Credit Card Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType3"
                    v-model="getPictureType3"
                    name="getPictureType3"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType3 === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera3">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.credit_card_photo == '' || editData.credit_card_photo == null">
                      <span class="error">The credit_card_photo field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture3'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture3')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video3" id="video3" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera3()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture3">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto3'"
                        id="takePhotoCanvas3"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType3 === 'uploadFile'">
                    <b-form-file
                      name="credit_card_photo"
                      @change="previewImage3"
                      accept="image/*"
                      v-model="editData.credit_card_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData3.length > 0">
                      <img class="preview" :src="imageData3" />
                    </div>
                    <!-- <span class="error">{{ errors.first('credit_card_photo') }}</span> -->
                  </div>
                </b-col>
              </b-row>

              <!-- update kartu keluarga -->
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Family Card</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="other_person_family_card" @change="previewImage7"
                    accept="image/*, application/pdf" v-model="additionalData1.family_card" ref="family_card"
                    :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png, pdf | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData7.length > 0">
                      <img class="preview" :src="imageData7" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('family card')"
                        v-if="additionalData1.family_card_update">Update Family Card</a>
                    </template>
                    <template v-else>
                      <template v-if="detectFileType(additionalData1.family_card) == 'image'">
                        <img class="preview" :src="additionalData1.family_card ? additionalData1.family_card : ''" />
                      </template>
                      <!-- pdf -->
                      <template v-if="detectFileType(additionalData1.family_card) == 'pdf'">
                        <a :href="additionalData1.family_card ? additionalData1.family_card : ''" target="_blank">Preview</a>
                      </template>

                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                </b-col>
              </b-row>


              <!-- Other CC -->
               <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="image_blog">Other Credit Card</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-file name="other_credit_card_photo" @change="previewImage8"
                      accept="image/*" v-model="additionalData1.other_credit_card_photo" ref="other_credit_card_photo"
                      :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                    <small class="text-muted">Format: jpg, jpeg, png | Max Size: 1MB</small>
                    <div class="image-preview">
                      <template v-if="imageData8.length > 0">
                        <img class="preview" :src="imageData8" />
                        <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('other_credt_card')"
                          v-if="additionalData1.other_credit_card_update">Update Other Card</a>
                      </template>
                      <template v-else>
                        <img class="preview" :src="additionalData1.other_credit_card_photo" />
                      </template>
                    </div>
                    <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Other File</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="other_file" @change="previewImage9"
                    accept="image/*, application/pdf" v-model="additionalData1.other_file" ref="other_file"
                    :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <small class="text-muted">Format: jpg, jpeg, png, pdf | Max Size: 1MB</small>
                  <div class="image-preview">
                    <template v-if="imageData9.length > 0">
                      <img class="preview" :src="imageData9" />
                      <a class="btn btn-primary ml-3 px-3" @click="updateLeadsPhoto('other_file')"
                        v-if="additionalData1.other_credit_card_update">Update Other File</a>
                    </template>
                    <template v-else>
                      <template v-if="detectFileType(additionalData1.other_file) == 'image'">
                        <img class="preview" :src="additionalData1.other_file" />
                      </template>
                      <!-- pdf -->
                      <template v-if="detectFileType(additionalData1.other_file) == 'pdf'">
                        <a :href="additionalData1.other_file" target="_blank">Preview</a>
                      </template>
                    </template>
                  </div>
                  <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                </b-col>
              </b-row>


            </div>
          </div>
          <!-- <template v-if="editData.doc_name === 'form_paradigm_2.hbs' || editData.doc_name === 'form_paradigm_3.hbs'">
            <div class="font-bold mt-20">Additional information</div>
            <hr class="short-line left">
            <div class="row mb-20">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">First Name</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_first_name" name="other_person_first_name"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('other_person_first_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Last Name</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_last_name" name="other_person_last_name"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('other_person_last_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">ID Card</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" name="id_card_others"  v-model="editData.other_person_no_ktp" type="text"></b-form-input>
                    <span class="error">{{ errors.first('id_card_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Place of Birth</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_tempat_lahir" name="place_of_birth_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('place_of_birth_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Birthday</div>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="config" v-model="editData.other_person_birthday" name="birthday_others"  class="w-100"></flat-pickr>
                    <span class="error">{{ errors.first('birthday_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Gender</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-radio-group id="other_person_gender"  v-model="editData.other_person_gender_id" name="other_person_gender">
                      <b-form-radio class="font-13" value="1">Male</b-form-radio>
                      <b-form-radio class="font-13" value="2">Female</b-form-radio>
                    </b-form-radio-group>
                    <span class="error">{{ errors.first('other_person_gender') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Nationality</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_kewarganegaraan" name="nationality_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('nationality_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Religion</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select name="others_religion"  v-model="editData.other_person_agama" class="form-control border-bottom">
                      <option value="null" selected>Please select</option>
                      <option value="Islam">Islam</option>
                      <option value="Kristen">Kristen</option>
                      <option value="Katolik">Katolik</option>
                      <option value="Hindu">Hindu</option>
                      <option value="Buddha">Buddha</option>
                      <option value="Konghucu">Konghucu</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('others_religion') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Maritial Status</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-radio-group id="maritial_status_others"  v-model="editData.other_person_status_perkawinan" name="maritial_status_others">
                      <b-form-radio class="font-13" value="Belum Kawin">Single</b-form-radio>
                      <b-form-radio class="font-13" value="Kawin">Marriage</b-form-radio>
                    </b-form-radio-group>
                    <span class="error">{{ errors.first('maritial_status_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Blood type</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select name="bloodType_others"  v-model="editData.other_person_golongan_darah" class="form-control border-bottom">
                      <option value="null" selected>Please select</option>
                      <option value="O">O</option>
                      <option value="A">A</option>
                      <option value="AB">AB</option>
                      <option value="B">B</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('bloodType_others') }}</span>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Address</div>
                  </b-col>
                  <b-col sm="9">
                    <textarea class="form-control"  name="address_others" v-model="editData.other_person_address" rows="3"></textarea>
                    <span class="error">{{ errors.first('address_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Province</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_provinsi" name="province_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('province_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Regency</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_kota" name="regency_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('regency_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">District</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_kecamatan" name="district_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('district_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">Sub District</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_kelurahan" name="subDistrict_others"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('subDistrict_others') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div class="label-name">RT/RW</div>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="form-control border-bottom" v-model="editData.other_person_rt_rw" name="other_person_rt_rw"  type="text"></b-form-input>
                    <span class="error">{{ errors.first('other_person_rt_rw') }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </template>-->
          <div
            class="row mb-20"
            v-if="editData.doc_name === 'form_paradigm_2.hbs' || editData.doc_name === 'form_paradigm_3.hbs' || editData.doc_name === 'form_paradigm_5.hbs' || editData.doc_name === 'form_paradigm_6.hbs'"
          >
            <div class="col-lg-6">
              <div class="font-bold mt-20">Upload Data Other</div>
              <hr class="short-line left" />
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Selfie Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType4"
                    v-model="getPictureType4"
                    name="getPictureType4"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType4 === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera4">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.other_person_selfie_photo == '' || editData.other_person_selfie_photo == null">
                      <span class="error">The other_person_selfie_photo field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture4'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture4')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video4" id="video4" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera4()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture4">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto4'"
                        id="takePhotoCanvas4"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType4 === 'uploadFile'">
                    <b-form-file
                      name="other_person_selfie_photo_2"
                      @change="previewImage4"
                      accept="image/*"
                      v-model="editData.other_person_selfie_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData4.length > 0">
                      <img class="preview" :src="imageData4" />
                    </div>
                    <!-- <span class="error">{{ errors.first('other_person_selfie_photo') }}</span> -->
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">ID Card Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType5"
                    v-model="getPictureType5"
                    name="getPictureType5"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType5 === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera5">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.other_person_ktp_photo == '' || editData.other_person_ktp_photo == null">
                      <span class="error">The id_card field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture5'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture5')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video5" id="video5" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera5()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture5">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto5'"
                        id="takePhotoCanvas5"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType5 === 'uploadFile'">
                    <b-form-file
                      name="id_card_2"
                      @change="previewImage5"
                      accept="image/*"
                      v-model="editData.other_person_ktp_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData5.length > 0">
                      <img class="preview" :src="imageData5" />
                    </div>
                    <!-- <span class="error">{{ errors.first('id_card') }}</span> -->
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_blog">Credit Card Photo</label>
                </b-col>
                <b-col sm="10">
                  <b-form-radio-group
                    id="pictureType6"
                    v-model="getPictureType6"
                    name="getPictureType6"
                  >
                    <b-form-radio class="font-13" value="takePicture">Take Picture</b-form-radio>
                    <b-form-radio class="font-13" value="uploadFile">Upload File</b-form-radio>
                  </b-form-radio-group>
                  <hr class="mb-10 mt-10" />
                  <div v-if="getPictureType6 === 'takePicture'">
                    <a class="btn-primary pt-10 pb-10 pl-25 pr-25 font-24" @click="openCamera6">
                      <i class="fas fa-camera"></i>
                    </a>
                    <!-- <div v-if="editData.other_person_credit_card_photo == '' || editData.other_person_credit_card_photo == null">
                      <span class="error">The other_person_credit_card_photo field is required.</span>
                    </div>-->
                    <b-modal
                      modal-class="modal-custom-image camera-custom"
                      no-close-on-backdrop
                      hide-header
                      hide-footer
                      :ref="'modalTakePicture6'"
                      centered
                      title="Take Picture"
                    >
                      <div class="p-0">
                        <div class="text-right">
                          <a
                            class="btn-close-camera color-white"
                            @click="closeCamera('modalTakePicture6')"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <video class="w-100" ref="video6" id="video6" autoplay></video>
                        <div class="text-center">
                          <a class="font-16 color-white" @click="toggleCamera6()">
                            <i class="fas fa-exchange-alt"></i>
                          </a>
                        </div>
                        <div class="d-flex justify-content-center bg-black pt-10 pb-10">
                          <a class="btn-camera font-18" @click="capture6">
                            <i class="fas fa-circle"></i>
                          </a>
                        </div>
                      </div>
                    </b-modal>
                    <div class="mt-10">
                      <canvas
                        class="photoResult w-100 hidden"
                        :ref="'showPhoto6'"
                        id="takePhotoCanvas6"
                      ></canvas>
                    </div>
                  </div>
                  <div v-if="getPictureType6 === 'uploadFile'">
                    <b-form-file
                      name="other_person_credit_card_photo_2"
                      @change="previewImage6"
                      accept="image/*"
                      v-model="editData.other_person_credit_card_photo"
                      :state="Boolean(file)"
                      placeholder="Choose a file..."
                    ></b-form-file>
                    <div class="image-preview" v-if="imageData6.length > 0">
                      <img class="preview" :src="imageData6" />
                    </div>
                    <!-- <span class="error">{{ errors.first('other_person_credit_card_photo') }}</span> -->
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- others data -->
            <div class="col-lg-6">
              <br>
              <div class="font-bold mt-20"></div>
              <hr class="short-line left" />
              <b-row class="mb-20"  style="margin-top: 30px;">
                <b-col sm="3">
                  <div class="label-name">Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.other_credit_card_name"
                    name="other_credit_card_name"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('other_credit_card_name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">No.KTP</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.other_credit_card_ktp"
                    name="other_credit_card_ktp"
                    v-validate="'required'"
                    type="number"
                  ></b-form-input>
                  <span class="error">{{ errors.first('other_credit_card_ktp') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">No. HP</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.other_credit_card_hp"
                    name="other_credit_card_hp"
                    v-validate="'required'"
                    type="number"
                  ></b-form-input>
                  <span class="error">{{ errors.first('other_credit_card_hp') }}</span>
                </b-col>
              </b-row>
              <!-- Alamat -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Alamat</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    class="form-control border-bottom"
                    v-model="editData.other_credit_card_alamat"
                    name="other_credit_card_alamat"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('other_credit_card_alamat') }}</span>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="font-bold mt-20">Credit Card</div>
          <hr class="short-line left" />
          <div class="row mb-20">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Holder Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.credit_card_holder_name"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Number</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom bg-transparent"
                    v-model="editData.credit_card_number" name="credit_card_number" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Bank Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="editData.credit_card_bank_name"
                    name="credit_card_bank_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Type</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_type" class="form-control border-bottom bg-transparent"
                    v-model="editData.credit_card_type">
                    <option value="VISA">VISA</option>
                    <option value="Mastercard">Mastercard</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Month Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select name="credit_card_month_expired" class="form-control border-bottom"
                    v-model="editData.credit_card_month_expired">
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Credit Card Year Expired</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom bg-transparent"
                    v-model="editData.credit_card_year_expired" name="credit_card_year_expired" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-right">
            <button v-if="!isViewOnly" type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
        <div v-if="loadingActive == true" class="loading-container">
          <div class="wrap-screen w-100 h-100">
            <img :src="`/svg-loaders/oval.svg`" width="60" alt />
            <div class="title-loading color-white">Saving Data ...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "editLeads",
  components: {
    ModelSelect
  },
  mixins: [Mixin],
  data: function() {
    return {
      loadingActive: false,
      branch_id: null,
      dataBranch: [],
      isActive: false,
      getPictureType: "takePicture",
      getPictureType2: "takePicture",
      getPictureType3: "takePicture",
      getPictureType4: "takePicture",
      getPictureType5: "takePicture",
      getPictureType6: "takePicture",
      mediaStream: null,
      mediaStream2: null,
      mediaStream3: null,
      mediaStream4: null,
      mediaStream5: null,
      mediaStream6: null,
      localstream: null,
      localstream2: null,
      localstream3: null,
      localstream4: null,
      localstream5: null,
      localstream6: null,
      video: {},
      video2: {},
      video3: {},
      video4: {},
      video5: {},
      video6: {},
      front: true,
      imageData: "",
      imageData2: "",
      imageData3: "",
      imageData4: "",
      imageData5: "",
      imageData6: "",
      imageData7: "",
      imageData8: "",
      imageData9: "",
      file: null,
      config: {},
      itemSales: [],
      itemSource: [],
      dataMember: [],
      optionCountryCode: [],
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      id_lead: "",
      checkSessionRoleId: "",
      editData: {
        doc_name: "",
        owner_id: null,
        member_id: null,
        source_type_id: null,
        first_name: "",
        last_name: "",
        email: "",
        no_ktp: "",
        phone_country_code: "",
        phone_number: "",
        home_number: "",
        birthday: moment(new Date()).format("YYYY-MM-DD"),
        gender: null,
        address: "",
        emergency_contact: "",
        emergency_number: "",
        ktp_photo: "",
        selfie_photo: "",
        credit_card_photo: "",
        tempat_lahir: "",
        agama: null,
        golongan_darah: null,
        kewarganegaraan: "",
        status_perkawinan: "",
        provinsi: "",
        kota: "",
        kecamatan: "",
        kelurahan: "",
        rt_rw: "",
        other_person_ktp_photo: "",
        other_person_selfie_photo: "",
        other_person_credit_card_photo: "",
        other_person_first_name: "",
        other_person_last_name: "",
        other_person_no_ktp: "",
        other_person_tempat_lahir: "",
        other_person_gender_id: "",
        other_person_agama: null,
        other_person_golongan_darah: null,
        other_person_kewarganegaraan: "",
        other_person_status_perkawinan: "",
        other_person_birthday: moment(new Date()).format("YYYY-MM-DD"),
        other_person_address: "",
        other_person_provinsi: "",
        other_person_kota: "",
        other_person_kecamatan: "",
        other_person_kelurahan: "",
        other_person_rt_rw: "",
        other_credit_card_name: "",
        other_credit_card_ktp: "",
        other_credit_card_hp: "",
        other_credit_card_alamat: "",
        referral_pt_id: null,
        isViewOnly: false,
        credit_card_holder_name: "",
        credit_card_number: "4811111111111114",
        credit_card_bank_name: "",
        credit_card_type: "VISA",
        credit_card_month_expired: "",
        credit_card_year_expired: "27"
      },
      additionalData1: {
        family_card: "",
        family_card_update: true,
        other_credit_card_photo: "",
        other_credit_card_update: true,
        other_file: "",
        other_file_update: true
      },
      currentData: {}, // untuk tampilin data yg lain
      options: [
        { value: null, text: "Please select" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ]
    };
  },
  methods: {
    changeBranch(event) {
      this.fetchData()
    },
    toggleCamera() {
      // console.log('1',this.isActive)
      this.isActive = !this.isActive;
      // console.log('2',this.isActive)
      if (this.isActive) {
        // console.log('3',this.isActive)
        this.camera("environment");
      } else {
        this.camera("user");
      }
    },
    toggleCamera2() {
      // console.log('1',this.isActive)
      this.isActive = !this.isActive;
      // console.log('2',this.isActive)
      if (this.isActive) {
        // console.log('3',this.isActive)
        this.camera2("environment2");
      } else {
        this.camera2("user2");
      }
    },
    toggleCamera3() {
      // console.log('1',this.isActive)
      this.isActive = !this.isActive;
      // console.log('2',this.isActive)
      if (this.isActive) {
        // console.log('3',this.isActive)
        this.camera3("environment3");
      } else {
        this.camera3("user3");
      }
    },
    toggleCamera4() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.camera4("environment4");
      } else {
        this.camera4("user4");
      }
    },
    toggleCamera5() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.camera5("environment5");
      } else {
        this.camera5("user5");
      }
    },
    toggleCamera6() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.camera6("environment6");
      } else {
        this.camera6("user6");
      }
    },
    closeCamera(id) {
      this.$refs[id].hide();
      this.stop();
      this.stop2();
      this.stop3();
      this.stop4();
      this.stop5();
      this.stop6();
    },
    openCamera() {
      this.camera("user");
      this.showModal("modalTakePicture");
    },
    openCamera2() {
      this.camera2("user2");
      this.showModal("modalTakePicture2");
    },
    openCamera3() {
      this.camera3("user3");
      this.showModal("modalTakePicture3");
    },
    openCamera4() {
      this.camera4("user4");
      this.showModal("modalTakePicture4");
    },
    openCamera5() {
      this.camera5("user5");
      this.showModal("modalTakePicture5");
    },
    openCamera6() {
      this.camera6("user6");
      this.showModal("modalTakePicture6");
    },
    capture() {
      const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
      const imageCapture = new window.ImageCapture(mediaStreamTrack);
      return imageCapture
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap => {
          // var reader = new FileReader()
          // reader.readAsDataURL(imageBitmap.blob)
          // reader.onloadend = function() {
          //   console.log(reader.result)
          // }
          this.editData.selfie_photo = imageBitmap.blob;
          this.$refs["showPhoto"].classList.remove("hidden");
          const canvas = document.querySelector("#takePhotoCanvas");
          this.drawCanvas(canvas, imageBitmap.bitmap);
          this.$refs["modalTakePicture"].hide();
          this.stop();
        });
    },
    capture2() {
      const mediaStreamTrack2 = this.mediaStream2.getVideoTracks()[0];
      const imageCapture2 = new window.ImageCapture(mediaStreamTrack2);
      return imageCapture2
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap2 => {
          // console.log(imageBitmap2)
          this.editData.ktp_photo = imageBitmap2.blob;
          this.$refs["showPhoto2"].classList.remove("hidden");
          const canvas2 = document.querySelector("#takePhotoCanvas2");
          this.drawCanvas2(canvas2, imageBitmap2.bitmap);
          this.$refs["modalTakePicture2"].hide();
          this.stop2();
        });
    },
    capture3() {
      const mediaStreamTrack3 = this.mediaStream3.getVideoTracks()[0];
      const imageCapture3 = new window.ImageCapture(mediaStreamTrack3);
      return imageCapture3
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap3 => {
          // console.log(imageBitmap3)
          this.editData.credit_card_photo = imageBitmap3.blob;
          this.$refs["showPhoto3"].classList.remove("hidden");
          const canvas3 = document.querySelector("#takePhotoCanvas3");
          this.drawCanvas3(canvas3, imageBitmap3.bitmap);
          this.$refs["modalTakePicture3"].hide();
          this.stop3();
        });
    },
    capture4() {
      const mediaStreamTrack4 = this.mediaStream4.getVideoTracks()[0];
      const imageCapture4 = new window.ImageCapture(mediaStreamTrack4);
      return imageCapture4
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap4 => {
          // console.log(imageBitmap4)
          this.editData.other_person_selfie_photo = imageBitmap4.blob;
          this.$refs["showPhoto4"].classList.remove("hidden");
          const canvas4 = document.querySelector("#takePhotoCanvas4");
          this.drawCanvas4(canvas4, imageBitmap4.bitmap);
          this.$refs["modalTakePicture4"].hide();
          this.stop4();
        });
    },
    capture5() {
      const mediaStreamTrack5 = this.mediaStream5.getVideoTracks()[0];
      const imageCapture5 = new window.ImageCapture(mediaStreamTrack5);
      return imageCapture5
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap5 => {
          // console.log(imageBitmap5)
          this.editData.other_person_ktp_photo = imageBitmap5.blob;
          this.$refs["showPhoto5"].classList.remove("hidden");
          const canvas5 = document.querySelector("#takePhotoCanvas5");
          this.drawCanvas5(canvas5, imageBitmap5.bitmap);
          this.$refs["modalTakePicture5"].hide();
          this.stop5();
        });
    },
    capture6() {
      const mediaStreamTrack6 = this.mediaStream6.getVideoTracks()[0];
      const imageCapture6 = new window.ImageCapture(mediaStreamTrack6);
      return imageCapture6
        .takePhoto()
        .then(async blob => {
          return {
            blob,
            bitmap: await createImageBitmap(blob)
          };
        })
        .then(imageBitmap6 => {
          // console.log(imageBitmap6)
          this.editData.other_person_credit_card_photo = imageBitmap6.blob;
          this.$refs["showPhoto6"].classList.remove("hidden");
          const canvas6 = document.querySelector("#takePhotoCanvas6");
          this.drawCanvas6(canvas6, imageBitmap6.bitmap);
          this.$refs["modalTakePicture6"].hide();
          this.stop6();
        });
    },
    camera(face) {
      this.stop();
      this.gum(face);
    },
    camera2(face) {
      this.stop2();
      this.gum2(face);
    },
    camera3(face) {
      this.stop3();
      this.gum3(face);
    },
    camera4(face) {
      this.stop4();
      this.gum4(face);
    },
    camera5(face) {
      this.stop5();
      this.gum5(face);
    },
    camera6(face) {
      this.stop6();
      this.gum6(face);
    },
    stop() {
      return video.srcObject && video.srcObject.getTracks().map(t => t.stop());
    },
    stop2() {
      return (
        video2.srcObject && video2.srcObject.getTracks().map(t => t.stop())
      );
    },
    stop3() {
      return (
        video3.srcObject && video3.srcObject.getTracks().map(t => t.stop())
      );
    },
    stop4() {
      return (
        video4.srcObject && video4.srcObject.getTracks().map(t => t.stop())
      );
    },
    stop5() {
      return (
        video5.srcObject && video5.srcObject.getTracks().map(t => t.stop())
      );
    },
    stop6() {
      return (
        video6.srcObject && video6.srcObject.getTracks().map(t => t.stop())
      );
    },
    gum(face) {
      if (face === "user") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video.srcObject = stream;
            this.localstream = stream;
            this.mediaStream = stream;
          });
      }
      if (face === "environment") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video.srcObject = stream;
            this.localstream = stream;
            this.mediaStream = stream;
          });
      }
    },
    gum2(face) {
      if (face === "user2") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video2.srcObject = stream;
            this.localstream2 = stream;
            this.mediaStream2 = stream;
          });
      }
      if (face === "environment2") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video2.srcObject = stream;
            this.localstream2 = stream;
            this.mediaStream2 = stream;
          });
      }
    },
    gum3(face) {
      if (face === "user3") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video3.srcObject = stream;
            this.localstream3 = stream;
            this.mediaStream3 = stream;
          });
      }
      if (face === "environment3") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video3.srcObject = stream;
            this.localstream3 = stream;
            this.mediaStream3 = stream;
          });
      }
    },
    gum4(face) {
      if (face === "user4") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video4.srcObject = stream;
            this.localstream4 = stream;
            this.mediaStream4 = stream;
          });
      }
      if (face === "environment4") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video4.srcObject = stream;
            this.localstream4 = stream;
            this.mediaStream4 = stream;
          });
      }
    },
    gum5(face) {
      if (face === "user5") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video5.srcObject = stream;
            this.localstream5 = stream;
            this.mediaStream5 = stream;
          });
      }
      if (face === "environment5") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video5.srcObject = stream;
            this.localstream5 = stream;
            this.mediaStream5 = stream;
          });
      }
    },
    gum6(face) {
      if (face === "user6") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: face } })
          .then(stream => {
            video6.srcObject = stream;
            this.localstream6 = stream;
            this.mediaStream6 = stream;
          });
      }
      if (face === "environment6") {
        return navigator.mediaDevices
          .getUserMedia({ video: { facingMode: { exact: face } } })
          .then(stream => {
            video6.srcObject = stream;
            this.localstream6 = stream;
            this.mediaStream6 = stream;
          });
      }
    },
    drawCanvas(canvas, img) {
      canvas.width = getComputedStyle(canvas).width.split("px")[0];
      canvas.height = getComputedStyle(canvas).height.split("px")[0];
      let ratio = Math.min(
        canvas.width / img.width,
        canvas.height / img.height
      );
      let x = (canvas.width - img.width * ratio) / 2;
      let y = (canvas.height - img.height * ratio) / 2;
      canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
      canvas
        .getContext("2d")
        .drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          x,
          y,
          img.width * ratio,
          img.height * ratio
        );
    },
    drawCanvas2(canvas2, img2) {
      canvas2.width = getComputedStyle(canvas2).width.split("px")[0];
      canvas2.height = getComputedStyle(canvas2).height.split("px")[0];
      let ratio = Math.min(
        canvas2.width / img2.width,
        canvas2.height / img2.height
      );
      let x = (canvas2.width - img2.width * ratio) / 2;
      let y = (canvas2.height - img2.height * ratio) / 2;
      canvas2.getContext("2d").clearRect(0, 0, canvas2.width, canvas2.height);
      canvas2
        .getContext("2d")
        .drawImage(
          img2,
          0,
          0,
          img2.width,
          img2.height,
          x,
          y,
          img2.width * ratio,
          img2.height * ratio
        );
    },
    drawCanvas3(canvas3, img3) {
      canvas3.width = getComputedStyle(canvas3).width.split("px")[0];
      canvas3.height = getComputedStyle(canvas3).height.split("px")[0];
      let ratio = Math.min(
        canvas3.width / img3.width,
        canvas3.height / img3.height
      );
      let x = (canvas3.width - img3.width * ratio) / 2;
      let y = (canvas3.height - img3.height * ratio) / 2;
      canvas3.getContext("2d").clearRect(0, 0, canvas3.width, canvas3.height);
      canvas3
        .getContext("2d")
        .drawImage(
          img3,
          0,
          0,
          img3.width,
          img3.height,
          x,
          y,
          img3.width * ratio,
          img3.height * ratio
        );
    },
    drawCanvas4(canvas4, img4) {
      canvas4.width = getComputedStyle(canvas4).width.split("px")[0];
      canvas4.height = getComputedStyle(canvas4).height.split("px")[0];
      let ratio = Math.min(
        canvas4.width / img4.width,
        canvas4.height / img4.height
      );
      let x = (canvas4.width - img4.width * ratio) / 2;
      let y = (canvas4.height - img4.height * ratio) / 2;
      canvas4.getContext("2d").clearRect(0, 0, canvas4.width, canvas4.height);
      canvas4
        .getContext("2d")
        .drawImage(
          img4,
          0,
          0,
          img4.width,
          img4.height,
          x,
          y,
          img4.width * ratio,
          img4.height * ratio
        );
    },
    drawCanvas5(canvas5, img5) {
      canvas5.width = getComputedStyle(canvas5).width.split("px")[0];
      canvas5.height = getComputedStyle(canvas5).height.split("px")[0];
      let ratio = Math.min(
        canvas5.width / img5.width,
        canvas5.height / img5.height
      );
      let x = (canvas5.width - img5.width * ratio) / 2;
      let y = (canvas5.height - img5.height * ratio) / 2;
      canvas5.getContext("2d").clearRect(0, 0, canvas5.width, canvas5.height);
      canvas5
        .getContext("2d")
        .drawImage(
          img5,
          0,
          0,
          img5.width,
          img5.height,
          x,
          y,
          img5.width * ratio,
          img5.height * ratio
        );
    },
    drawCanvas6(canvas6, img6) {
      canvas6.width = getComputedStyle(canvas6).width.split("px")[0];
      canvas6.height = getComputedStyle(canvas6).height.split("px")[0];
      let ratio = Math.min(
        canvas6.width / img6.width,
        canvas6.height / img6.height
      );
      let x = (canvas6.width - img6.width * ratio) / 2;
      let y = (canvas6.height - img6.height * ratio) / 2;
      canvas6.getContext("2d").clearRect(0, 0, canvas6.width, canvas6.height);
      canvas6
        .getContext("2d")
        .drawImage(
          img6,
          0,
          0,
          img6.width,
          img6.height,
          x,
          y,
          img6.width * ratio,
          img6.height * ratio
        );
    },
    validateRegister() {
      this.loadingActive = true;

      if (
        this.editData.doc_name === "form_paradigm_2.hbs" ||
        this.editData.doc_name === "form_paradigm_3.hbs"
      ) {
        this.$validator.validateAll().then(result => {
          if (result) {
            // axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
            var data = new FormData();
            Object.keys(this.editData).forEach(keyName => {
              data.append(keyName, this.editData[keyName]);
            });
            if (typeof this.editData.ktp_photo === "object") {
              data.set(
                "ktp_photo",
                new File([this.editData.ktp_photo], "id_card_photo.jpg")
              );
            }
            if (typeof this.editData.selfie_photo === "object") {
              data.set(
                "selfie_photo",
                new File([this.editData.selfie_photo], "selfie_photo.jpg")
              );
            }
            if (typeof this.editData.credit_card_photo === "object") {
              data.set(
                "credit_card_photo",
                new File(
                  [this.editData.credit_card_photo],
                  "credit_card_photo.jpg"
                )
              );
            }
            if (typeof this.editData.other_person_ktp_photo === "object") {
              data.set(
                "other_person_ktp_photo",
                new File(
                  [this.editData.other_person_ktp_photo],
                  "other_id_card_photo.jpg"
                )
              );
            }
            if (typeof this.editData.other_person_selfie_photo === "object") {
              data.set(
                "other_person_selfie_photo",
                new File(
                  [this.editData.other_person_selfie_photo],
                  "other_selfie_photo.jpg"
                )
              );
            }
            if (
              typeof this.editData.other_person_credit_card_photo === "object"
            ) {
              data.set(
                "other_person_credit_card_photo",
                new File(
                  [this.editData.other_person_credit_card_photo],
                  "other_credit_card_photo.jpg"
                )
              );
            }

            // data.append('other_person_ktp_photo', this.editData.other_person_ktp_photo)
            // data.append('other_person_selfie_photo', this.editData.other_person_selfie_photo)
            // data.append('other_person_credit_card_photo', this.editData.other_person_credit_card_photo)
            // var blob = new Blob([JSON.stringify([0,1,2])], {type : 'application/json'})
            // data.append("photos", blob, this.editData.selfie_photo)
            // console.log(this.editData.selfie_photo)
            axios
              .put("crm/v1/leads/" + this.$route.query.id, data)
              .then(response => {
                // console.log('test', response)
                this.loadingActive = false;
                this.$router.push("/leads");
                this.$toast.success("data saved successfully!", "Success", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
              })
              .catch(error => {
                // console.log('error', error)
                this.loadingActive = false;
                if (error.response.data) {
                  this.$toast.success(error.response.data.error, "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                } else {
                  this.$toast.success("Cant saved data!", "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                }
              });
          } else {
            this.loadingActive = false;
            this.$toast.success("please fill in required fields!", "Error", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff"
            });
          }
        });
      } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            // axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
            var data = new FormData();
            Object.keys(this.editData).forEach(keyName => {
              data.append(keyName, this.editData[keyName]);
            });
            if (typeof this.editData.ktp_photo === "object") {
              data.set(
                "ktp_photo",
                new File([this.editData.ktp_photo], "id_card_photo.jpg")
              );
            }
            if (typeof this.editData.selfie_photo === "object") {
              data.set(
                "selfie_photo",
                new File([this.editData.selfie_photo], "selfie_photo.jpg")
              );
            }
            if (typeof this.editData.credit_card_photo === "object") {
              data.set(
                "credit_card_photo",
                new File(
                  [this.editData.credit_card_photo],
                  "credit_card_photo.jpg"
                )
              );
            }
            // var blob = new Blob([JSON.stringify([0,1,2])], {type : 'application/json'})
            // data.append("photos", blob, this.editData.selfie_photo)
            // console.log(this.editData.selfie_photo)
            axios
              .put("crm/v1/leads/" + this.$route.query.id, data)
              .then(response => {
                // console.log('test', response)
                this.loadingActive = false;
                this.$router.push("/leads");
                this.$toast.success("data saved successfully!", "Success", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
              })
              .catch(error => {
                // console.log('error', error)
                this.loadingActive = false;
                if (error.response.data) {
                  this.$toast.success(error.response.data.error, "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                } else {
                  this.$toast.success("Cant saved data!", "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                }
              });
          } else {
            this.loadingActive = false;
            this.$toast.success("please fill in required fields!", "Error", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff"
            });
          }
        });
      }
    },
    showModal(id) {
      this.$refs[id].show();
    },
    hideModal(id) {
      this.$refs[id].hide();
    },
    openPage(event) {
      this.$router.push(event);
    },
    detectFileType(url) {
      if (!url || typeof url !== 'string') return null;

      const lowerUrl = url.toLowerCase();

      if (/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/.test(lowerUrl)) {
        return 'image';
      } else if (/\.(pdf)$/.test(lowerUrl)) {
        return 'pdf';
      } else {
        return 'unknown';
      }
    },
    updateLeadsPhoto(type) {
      const formData = new FormData();
      if (type === "family card") {
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formData.append("file", this.additionalData1.family_card);
        axios
          .post("storage/upload", formData)
          .then(response => {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            const family_card_photo = {
              family_card: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.$route.query.id, family_card_photo).then(response => {
                this.additionalData1.family_card = "";
                this.additionalData1.family_card_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Family Card Photo",
                  "success"
                );
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
            this.$swal(
                  "Failed",
                  "Your have failed update Family Card Photo! Please try again another file!",
                  "error"
                );
          });
      }

      if (type === "other_credt_card") {
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formData.append("file", this.additionalData1.other_credit_card_photo);
        axios
          .post("storage/upload", formData)
          .then(response => {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            const upload_other_file = {
              other_credit_card_photo: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.$route.query.id, upload_other_file).then(response => {
                this.additionalData1.other_credit_card_photo = "";
                this.additionalData1.other_credit_card_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Other Credit Card",
                  "success"
                );
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
            this.$swal(
                  "Failed",
                  "Your have failed update Other Credit Card! Please try again another file!",
                  "error"
                );
          });
      }

      if (type === "other_file") {
        axios.defaults.baseURL = "https://digmsix.paradigmfitnessindonesia.com/s3/"
        formData.append("file", this.additionalData1.other_file);
        axios
          .post("storage/upload", formData)
          .then(response => {
            axios.defaults.baseURL = process.env.VUE_APP_API_URL
            const otherfile = {
              other_file: response.data.data.location
            }
            axios
              .put("crm/v1/leads/upload_other_file/" + this.$route.query.id, otherfile).then(response => {
                this.additionalData1.other_file = "";
                this.additionalData1.other_file_update = false;
                this.$swal(
                  "Success",
                  "Your have successfully update Other File!",
                  "success"
                );
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
            this.$swal(
                  "Failed",
                  "Your have failed update Other File! Please try again another file!",
                  "error"
                );
          });
      }
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage2: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData2 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage3: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData3 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage4: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData4 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage5: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData5 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage6: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData6 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage7: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData7 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage8: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData8 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImage9: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData9 = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
     onCountryCode(event) {
      console.log("event", event);
      // this.phone_country_code = event;
    },
    normalizePhoneNumber(field) {
      // Country code +62 sudah dipilih terpisah di dropdown, jadi field ini harus
      // nomor nasional TANPA 0 di depan (bukan "0812...", tapi "812...").
      const raw = this.editData[field]
      if (!raw) return
      let cleaned = `${raw}`.replace(/[^0-9+]/g, '')
      if (cleaned.startsWith('+62')) {
        cleaned = cleaned.slice(3)
      } else if (cleaned.startsWith('62') && cleaned.length > 9) {
        cleaned = cleaned.slice(2)
      }
      cleaned = cleaned.replace(/\+/g, '')
      cleaned = cleaned.replace(/^0+/, '')
      if (cleaned !== raw) {
        this.editData[field] = cleaned
      }
    },
    fetchData() {
      // this.getMember()
      this.getMemberWithoutBranch()
      this.id_lead = this.$route.query.id;
      axios
        .get("crm/v1/leads/" + this.$route.query.id)
        .then(response => {
          this.editData = response.data.data;
          // dummy CC, tetap fixed & tidak bisa diedit walau field ini tidak ada di data lead
          this.editData.credit_card_number = "4811111111111114";
          this.editData.credit_card_type = "VISA";
          this.editData.credit_card_year_expired = "27";
          this.currentData = response.data.data;
          this.additionalData1.other_file = response.data.data.other_file;
          this.additionalData1.family_card = response.data.data.family_card;
          this.additionalData1.other_credit_card_photo = response.data.data.other_credit_card_photo;

          this.imageData =
            Auth.apiUrl + "crm/v1/img/leads/" + response.data.data.selfie_photo;
          this.imageData2 =
            Auth.apiUrl + "crm/v1/img/leads/" + response.data.data.ktp_photo;
          this.imageData3 =
            Auth.apiUrl +
            "crm/v1/img/leads/" +
            response.data.data.credit_card_photo;
          this.imageData4 =
            Auth.apiUrl +
            "crm/v1/img/leads/" +
            response.data.data.other_person_selfie_photo;
          this.imageData5 =
            Auth.apiUrl +
            "crm/v1/img/leads/" +
            response.data.data.other_person_ktp_photo;
          this.imageData6 =
            Auth.apiUrl +
            "crm/v1/img/leads/" +
            response.data.data.other_person_credit_card_photo;
          if (
            response.data.data.selfie_photo ||
            response.data.data.ktp_photo ||
            response.data.data.credit_card_photo ||
            response.data.data.other_person_selfie_photo ||
            response.data.data.other_person_ktp_photo ||
            response.data.data.other_person_credit_card_photo
          ) {
            this.getPictureType = "uploadFile";
            this.getPictureType2 = "uploadFile";
            this.getPictureType3 = "uploadFile";
            this.getPictureType4 = "uploadFile";
            this.getPictureType5 = "uploadFile";
            this.getPictureType6 = "uploadFile";
          }
        })
        .catch(error => {
          console.log("error", error);
        });
      if (Auth.Session.get().paradigm_role === "1") {
        axios
          .get("crm/v1/sales")
          .then(response => {
            this.itemSales = response.data.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        axios
          .get("crm/v1/sales/my_sales/" + Auth.Session.get().paradigm_id)
          .then(response => {
            this.itemSales = response.data.rows;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
      axios
        .get("crm/v1/leads_source_type?status=active")
        .then(response => {
          this.itemSource = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });

      // member list
      // axios
      //   .get("")
      //   .then(response => {
      //     // console.log(response.data.data.rows)
      //     this.dataMember = response.data.data.rows;
      //     for (var i = 0; i < this.dataMember.length; i++) {
      //       let memberBranchId;
      //       if (!this.dataMember[i].branch_id) {
      //         memberBranchId =
      //           this.dataMember[i].first_name +
      //           " " +
      //           this.dataMember[i].last_name;
      //       } else {
      //         memberBranchId =
      //           this.dataMember[i].first_name +
      //           " " +
      //           this.dataMember[i].last_name;
      //       }
      //       // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name})
      //       var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
      //       this.optionsMember.push(dataComplete);
      //     }
      //     // console.log('test', response)
      //   })
      //   .catch(error => {
      //     console.log("error", error);
      //   });

      axios
        .get(
          "fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=" + this.branch_id)
        .then((response) => {
          this.itemsPT = response.data.data.rows;
        })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios
        .get("crm/v1/country_code")
        .then(response => {
          this.optionCountryCode = [];
          for (let i = 0; i < response.data.data.length; i++) {
            const el = response.data.data[i];
            this.optionCountryCode.push({
              value: el.dial_codes,
              text: el.dial_codes + "  " + el.emoji + " " +  el.name
            });

          }
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.checkSessionRoleId = Auth.Session.get().paradigm_role;
    if (Auth.Session.get().paradigm_role === "4") {
      this.editData.owner_id = null;
    } else {
      this.editData.owner_id = Auth.Session.get().paradigm_id;
    }
    this.fetchData();

    const roleMapping = Auth.Session.get().paradigm_role_mapping_id
    const roleId = Auth.Session.get().paradigm_role
    if (roleMapping.includes(17)) {
      this.isViewOnly = true
    } else if (Number(roleId) == 33) {
      this.isViewOnly = true
    }
  }
};
</script>

<style>
</style>
